import { useState, useEffect, useRef, useCallback } from 'react'
import loadable from '@loadable/component'

// Functions
import uid from '../../functions/uid'
import isExact from '../../functions/is-exact'

// Component
const MessengerDom = loadable(() => import('./messenger-dom'), { ssr: false });

// Constants
const defaultMessage = {
	type: 'error',
	text: '',
}

export const pushMessage = (message, opts = {}) => {
	if (typeof window !== 'undefined') {
		const msgEvent = new CustomEvent('pushMessage', { detail: {
			...opts,
			text: message,
		} });
		window.dispatchEvent(msgEvent);
	}
}

export const Messenger = ({ styles=() => (import('./styles.scss')) }) => {
	const messagesRef = useRef([]);
	const messageSyncRef = useRef([]);
	const [messages, setMessagesRaw] = useState([])

	const setMessages = (newMessages) => {
		setMessagesRaw(newMessages);
		messageSyncRef.current = newMessages;
	}

	const syncMessages = useCallback(() => {
		if(!isExact(messagesRef.current, messageSyncRef.current)) {
			setMessages([...messagesRef.current]);
		}
	}, []);

	const addMessage = useCallback(({ detail }) => {
		messagesRef.current.push({
			...defaultMessage,
			...detail,
			id: uid('messenger-message'),
		});

		syncMessages();
	}, [syncMessages]);

	const removeMessage = useCallback((index) => {
		messagesRef.current.splice(index, 1);
		syncMessages();
	}, [syncMessages]);

	useEffect(() => {
		window.addEventListener('pushMessage', addMessage, false);

		return () => {
			window.removeEventListener('pushMessage', addMessage);
		}
	}, [addMessage])

	return (
		<MessengerDom styles={styles} onRemoveMessage={removeMessage} messages={messages} />
	)
}